<div *ngIf="checkViewMode('edit')" class="form-group switch-group currency editavel">
  <label for="">
    {{attribute.key}}
    <span class="error-indication" *ngIf="true">*</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info" [popover]="getOptionByKey(attribute,'tooltip')"
    placement="right"
    container="body"
    triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>
  <div>
    <ui-switch [checked]="isChecked" [disabled]="disabled ? true : false" (valueChange)="onValueChange($event)"></ui-switch>
    <input type="text" [tabindex]="getOptionByKey(attribute,'tabIndex')" currencyMask
      [(ngModel)]="attribute.value" [placeholder]="getOptionByKey(attribute,'placeholder')" [disabled]="!isChecked"
      class="form-control" [id]="getOptionByKey(attribute,'identifier')" >
  </div>
</div>

<div class="m-switch-text-view" *ngIf="checkViewMode('view') && attribute.value!=''&&attribute.value!= null">
  <div class="m-switch-text-view-container">
    <label> {{getOptionByKey(attribute,'hideTitle')== 'true'? '' : attribute.key}} </label>
    <p> {{attribute.value | currency:' ':'':'0.0-0'}}</p>
  </div>
</div>
<div class="m-switch-text-view" *ngIf="checkViewMode('view') && (attribute.value==''||attribute.value== null)">
  <div class="m-switch-text-view-container">
      <label> {{getOptionByKey(attribute,'hideTitle')== 'true'? '' : attribute.key}} </label>
      <p> {{textNotChecked}}</p>
    </div>

</div>
